import { componentFactory } from '../../../fc-core/src/lib';
import InputManager from './input-manager';
import DragZoomIn from './input-drag-zoom';
import ZoomResetButton from './zoom-reset';
import ZoomOutButton from './zoom-out';
import ZoomInButton from './zoom-in';
import DbTapZoom from './input-dbtap-zoom';
import DragPin from './input-drag-pin';
import DragPan from './input-pan';
import PinchZoom from './input-pinch-zoom';
import SwipeGesture from './input-swipe';
import { getDep } from '../../../fc-core/src/dependency-manager';
import raphaelShapesButton from '../../../fc-core/src/_internal/redraphael/redraphael-shapes/redraphael-shapes.button';
var inputMap = {
  DragZoomIn: DragZoomIn,
  ZoomResetButton: ZoomResetButton,
  ZoomOutButton: ZoomOutButton,
  DbTapZoom: DbTapZoom,
  DragPin: DragPin,
  ZoomInButton: ZoomInButton,
  DragPan: DragPan,
  PinchZoom: PinchZoom,
  SwipeGesture: SwipeGesture
};

function inputAdapter(a) {
  var b,
      c,
      d = getDep('redraphael', 'plugin');
  raphaelShapesButton(d), a.addEventListener('instantiated', function (a) {
    var d,
        e = a.sender;
    'canvas' === e.getType() && e.registerFactory('inputManager', function (a) {
      if (c = a.getFromEnv('chart'), b = c.constructor.includeInputOptions && c.constructor.includeInputOptions(), b) {
        componentFactory(a, InputManager, 'inputManager', 1, [{}]), d = a.getChildren('inputManager')[0];

        for (var _a = 0, _c = b && b.length; _a < _c; _a++) {
          componentFactory(d, inputMap[b[_a]], b[_a], 1, [{}]);
        }
      }
    });
  });
}

export default {
  extension: inputAdapter,
  name: 'inputAdapter',
  type: 'extension',
  requiresFusionCharts: !0
};